'use client';

import { createClient } from '@/lib/supabase/client';

export interface GameSettings {
  gameEnabled: boolean;
}

export const gameSettingsService = {
  async getSettings(): Promise<GameSettings> {
    const supabase = createClient();
    const { data, error } = await supabase
      .from('game_settings')
      .select('game_enabled')
      .eq('id', 1)
      .single();

    if (error) {
      // Default to enabled if table doesn't exist yet
      return { gameEnabled: true };
    }
    return { gameEnabled: data?.game_enabled ?? true };
  },

  async setGameEnabled(enabled: boolean): Promise<void> {
    const supabase = createClient();
    const { error } = await supabase
      .from('game_settings')
      .upsert({ id: 1, game_enabled: enabled, updated_at: new Date().toISOString() });

    if (error) throw new Error(error.message);
  },

  subscribeToSettings(callback: (settings: GameSettings) => void) {
    const supabase = createClient();
    const channel = supabase
      .channel('game_settings_changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'game_settings' },
        (payload) => {
          const row = payload.new as any;
          callback({ gameEnabled: row?.game_enabled ?? true });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  },
};
